<template>

  <b-modal size="lg" v-model="value" @click.prevent="closeShipmentModel" title="Confirmation">
    <div role="document">
      <div class="modal-content" >
        <div class="modal-headerfrm">
          <h4 class="modal-title">Pending Group Shipment List</h4>
          <button type="button" class="close" @click.prevent="closeShipmentModel" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-bodyfrm">
          <div class="row">
            <div class="col-md-12">
            <div class="text-success mb-2" style="font-weight:bold;">{{allocationSuccessMsg}}</div>
              <div class="text-danger mb-2" style="font-weight:bold;">{{ pendingGrouptErrorMsg }}</div>
              <vue-element-loading spinner="line-scale" color="#FF6700" :active.sync="isPendingGroupIdLoader" />
              <table class="b-table table table-bordered" style="width:100%">
                  <thead class="thead-default">
                  <tr>
                    <th>Sr No.</th>
                    <th>Shipping ID</th>
                  </tr>
                  </thead>
                  <tbody>
                    <template v-if="showParentGroupIdShipmentList.length>0">
                      <tr v-for="(row,index) in showParentGroupIdShipmentList" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{row}}</td>
                      </tr>
                    </template>
                    <template v-else>
                      <tr>
                        <td colspan="2" align="center">No record found</td>
                      </tr>
                    </template>
                  </tbody>
              </table>
            </div>
          </div>
        </div>
        <div class="modal-footerfrm mt-4" style="float:right">
          <button type="button" class="btn btn-danger" data-dismiss="modal" @click.prevent="closeShipmentModel()">close</button>
        </div>
      </div>
    </div>
  </b-modal>
</template>


<script>
import VueElementLoading from 'vue-element-loading';

export default {
  name: 'pendingGroupIdShipments',
  components: {
    VueElementLoading
  },
  data: function() {
    return{

    }
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    showParentGroupIdShipmentList: {
      type: Array,
      required: true,
    },
    isPendingGroupIdLoader: {
      type: Boolean,
      required: true,
    },
    pendingGrouptErrorMsg: {
      type: String,
      required: true
    },
    allocationSuccessMsg: {
      type: String
    }
  },
  methods: {
    closeShipmentModel(){
      this.$emit("input", !this.value);
      this.PassSelectedevent()
    },
    PassSelectedevent(){
      this.$emit("getCloseModelEvent", this.value);
    },
  }
}

</script>

<style lang="css" scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/common/pendingGroupIdShipments.vue?529fe38f